"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSL = void 0;
function viewSL() {
    return {
        constructor: function (props) {
        },
        mounted: function () {
        },
        events: {}
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowThankYouBackButtons/ViewSL.js
// module id = 372
// module chunks = 0 2